import {
  FetchResult,
  gql,
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
  useMutation,
} from '@apollo/client';

export interface IAcceptHumioTcVariables extends OperationVariables {
  humioSessionToken: string;
}

export const ACCEPT_HUMIO_TC = gql`
  mutation acceptHumioTC($humioSessionToken: String!) {
    acceptHumioTC(humioSessionToken: $humioSessionToken) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;

interface AcceptHumioTcResponse {
  acceptHumioTC: {
    status_code: number;
    body: { data: unknown; message: string; success: boolean };
  };
}

export const useAcceptHumioTC = (
  options?: MutationHookOptions<AcceptHumioTcResponse, IAcceptHumioTcVariables>,
): MutationTuple<AcceptHumioTcResponse, IAcceptHumioTcVariables> => {
  const [mutate, result] = useMutation<
    AcceptHumioTcResponse,
    IAcceptHumioTcVariables
  >(ACCEPT_HUMIO_TC, options);

  const safeMutate = async (
    mutationOptions?: Parameters<typeof mutate>[0],
  ): Promise<FetchResult<AcceptHumioTcResponse>> => {
    const variables = mutationOptions?.variables;

    if (
      !variables?.humioSessionToken ||
      variables.humioSessionToken === 'undefined' ||
      variables.humioSessionToken === '' ||
      variables.humioSessionToken === null
    ) {
      console.error(
        'Invalid Humio session token provided to acceptHumioTC:',
        variables?.humioSessionToken,
      );
      return Promise.reject(
        new Error(
          `Invalid Humio session token: "${variables?.humioSessionToken}"`,
        ),
      );
    }

    return mutate(mutationOptions);
  };

  return [safeMutate, result];
};
